export const specialChractorValidation = (data: any) => {
    if (data.length)
        return /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(data)
}

export const negativeNumberStringValidation = (data: any) => {
    if (data == null) {
        return false
    }
    if (data.length) {
        return /^[0-9]+$/.test(data)
    }
}

export const emailValidation = (data: any) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data)
}

export const negativeNumberValidation = (data: any) => {
    return /(?<!\d)-\d+\.?\d*/.test(data)
}

export const validatePhone = (phone) => {

    var regx = /^[6-9]\d{9}$/;
    if (regx.test(phone))
        return true
    else
        return false
}

export const validationChecking = (objects, CustomerDetail) => {
    let checking = false
    if (CustomerDetail.customerName && !specialChractorValidation(CustomerDetail.customerName)) {
      checking = Object.keys(objects).every((item) => {
        if (objects[item] && objects[item] !== '') {
          if (item == 'email1' || item == 'email2') {
            return emailValidation(objects[item])
          }
          if (item == 'iuiYear' || item == 'ivfYear' || item == 'iuiMonth' || item == 'ivfMonth' || item == 'miscarriagesYear' || item == 'miscarriagesMonth' || item == 'childrenONE' || item == 'childrenTWO' || item == 'childrenTHREE' || item == 'icsiMonth' || item == 'icsiYear') {
            return negativeNumberStringValidation(objects[item])
          }
          if (item == 'phone1' || item == 'phone2') {
            let number = objects[item].toString()
            return validatePhone(number)
          }
          if (item == 'spouseName' || item == 'occupation' || item == 'spouseOccupation' || item == 'areaOfInterest') {
            return /^[a-zA-Z\s]+$/.test(objects[item])
          }
          else {
            return true
          }
        }
        else {
          return true
        }
      })
    }
    return checking
  }
  export const validationCheckingContact = (objects, CustomerDetail) => {
    let checking = false;
    console.log(objects);
    
      checking =objects.length !== 0 &&  Object.keys(objects).every((item) => {
        if (objects[item] && (objects[item] !== '' || objects[item] !== null || objects[item] !== 0)) {
         
         
          return true;
        }
        return false;
      });
    
    return checking;
  };
  

